/* anchorLink
========================================================= */
export function anchorLink() {
  // ▼ クリック時のスムーススクロール
  document.addEventListener('click', function (e) {
    // まず「#pagetop の中」がクリックされたかどうかをチェック
    const pagetop = e.target.closest('#pagetop');
    if (pagetop) {
      // aでもdivでもOK。とにかく #pagetop 内なら最優先で処理
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      return;
    }

    // ここから先は「通常のアンカーリンク」用 --------------------------
    const link = e.target.closest('a[href]');
    if (!link) return;

    // 新しいタブで開くリンクなどは除外
    if (link.target === '_blank') return;

    const href = link.getAttribute('href');
    if (!href) return;

    // URLオブジェクトに変換（相対パスもOK）
    const url = new URL(href, window.location.href);

    // ① 同一ドメイン＆同一パス かつ ハッシュ付きのときだけ処理
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) {
      return; // 別ページへのリンクはそのまま遷移
    }

    const hash = url.hash; // 例: "#section01"

    // 単なる "#" などは無視
    if (hash === '#' || hash === '#0') return;

    const targetEl = document.querySelector(hash);
    if (!targetEl) return;

    e.preventDefault();

    const isPc = window.matchMedia('(min-width: 768px)').matches;
    const headerHeight = isPc ? 106 : 0; // PCだけ106px、SPは0

    const targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset - headerHeight;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  });

  // ▼ ページ読み込み時に、URLのハッシュがあればその位置へスクロールし直す
  window.addEventListener('load', function () {
    const hash = window.location.hash;
    if (!hash) return;

    // ページトップ系は何もしない
    if (hash === '#top' || hash === '#pagetop' || hash === '#page-top') {
      return;
    }

    const targetEl = document.querySelector(hash);
    if (!targetEl) return;

    const isPc = window.matchMedia('(min-width: 768px)').matches;
    const headerHeight = isPc ? 106 : 0;

    setTimeout(function () {
      const targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth', // 目立たせたくなければ 'auto' に
      });
    }, 0);
  });
}
